import { defineStore } from 'pinia';
import { ref } from 'vue'
import { searchApi } from '@/shared/api/search'

interface Result {
  type: 'merch' | 'preorder';
  entity_id: number;
  title: string;
  image_url: string;
  relevance: number;
  priority: number;
}

export const useSearch = defineStore('search', () => {
  const results = ref<Result[]>([]);
  const loading = ref(false);
  const error = ref<Error | null>(null);
  let abortController: AbortController | null = null;

  const fetchResult = async (query: string): Promise<void> => {
    // Отменяем предыдущий запрос, если он есть
    abortController?.abort();
    abortController = new AbortController();

    loading.value = true;
    error.value = null;

    try {
      results.value = (await searchApi.search(query, abortController.signal))
        .sort((a, b) => a.relevance - b.relevance);
    } catch (err) {
      if (err instanceof DOMException && err.name === 'AbortError') return;
      error.value = err as Error;
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    results,
    loading,
    error,
    fetchResult,
  };
});
